import { jsx as _jsx } from "react/jsx-runtime";
import { nanoid } from 'nanoid';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { TreeNode } from './tree-node';
import { recursiveFind, recursiveUpdateMultiSelection, recursiveUpdateSingleSelection, } from './tree-utils';
const Tree = ({ nodes, onSelected, selectable, size = 'sm', }) => {
    const parser = useCallback(_nodes => {
        return _nodes.map((n) => {
            if (n.nodes?.length) {
                return {
                    ...n,
                    id: nanoid(),
                    nodes: parser(n.nodes),
                    selected: false,
                };
            }
            return { ...n, id: nanoid() };
        });
    }, []);
    const [selectedId, setSelectedId] = useState();
    const [treeNodes, setTreeNodes] = useState(parser(nodes));
    const getLookupNode = useMemo(() => {
        if (selectedId) {
            const lookupNode = treeNodes.find(node => node.id === selectedId.lookupNodeId);
            return lookupNode;
        }
    }, [JSON.stringify(selectedId)]);
    useEffect(() => {
        const node = getLookupNode;
        if (node && selectedId) {
            const nodeToUpdate = JSON.parse(JSON.stringify(node));
            const idToFind = selectedId.id;
            let nodeUpdated;
            let nodesUpdated;
            if (selectable) {
                nodeUpdated = recursiveUpdateMultiSelection(nodeToUpdate, idToFind);
                setTreeNodes(prev => {
                    const result = prev.map(x => {
                        if (x.id === selectedId.lookupNodeId) {
                            return { ...nodeUpdated };
                        }
                        return x;
                    });
                    return result;
                });
            }
            else {
                nodesUpdated = recursiveUpdateSingleSelection(treeNodes, idToFind);
                setTreeNodes(nodesUpdated);
            }
            const selectedNode = recursiveFind(node, selectedId.id);
            if (selectedNode) {
                const { id, name } = selectedNode;
                onSelected?.({ id, name });
            }
        }
    }, [JSON.stringify(selectedId)]);
    const handleSelection = useCallback((id, open) => {
        if (!id) {
            return;
        }
        const ids = id.split('/');
        const idToFind = ids[ids.length - 1];
        const lookupNodeId = ids[0];
        setSelectedId({
            id: idToFind,
            lookupNodeId,
            selected: open || false,
            stamp: new Date().getTime(),
        });
    }, []);
    return (_jsx("div", { role: "tree", children: _jsx(TreeNode, { nodes: treeNodes, isChild: false, onSelect: handleSelection, enableCheckbox: selectable, size: size }) }));
};
export { Tree };
